import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import FormatCreationDate from '../../utils/FormatCreationDate';

const StyledBlogItemGrid = styled(Link)`
	.blogitem-list {
		column-gap: 60px;
	}

	h6 {
		font-size: 14px;
		font-weight: 700;
		line-height: 24px;
		text-align: left;
	}

	.description {
		font-size: 14px;
		font-weight: 400;
		line-height: 24px;
		text-align: left;
	}

	.blog-thumbnail {
		img {
			width: 100%;
			height: 240px;
			object-fit: cover;
			object-position: top;
		}
	}

	.blog-info {
		.blog-info-left {
			column-gap: 32px;
		}
	}

	h6,
	img {
		transition: all 0.3s ease-in-out;
	}

	&:hover {
		img {
			scale: 1.1;
		}

		h6 {
			color: ${({ tag }) => (tag === 'adc' ? '#f15b46' : '#CF004F')};
		}
	}

	.text-color-red {
		color: #f15b46;
	}

	.text-color-orange {
		color: #f15b46;
	}

	.text-color-blue {
		color: #518fa9;
	}
`;

const BlogItemGrid = ({ blogItem, brandDetails, category }) => {
	return (
		<StyledBlogItemGrid
			tag={brandDetails.tag}
			to={`/blog/${category?.replaceAll(' ', '-')}/${blogItem?.path}`}
			className='text-decoration-none'
		>
			<div className='blog-thumbnail mb-24 overflow-hidden'>
				<img
					src={blogItem?.thumbnail?.fields?.file?.url}
					alt={blogItem.title}
					title={blogItem.title}
				/>
			</div>
			<div className='d-flex flex-column align-items-start'>
				<div className='blog-info d-flex align-items-center justify-content-between mb-8 w-100'>
					<div className='blog-info-left d-flex align-items-center'>
						<div
							className={`category text_small ${
								blogItem?.category === 'INTERVIEWS'
									? 'text-color-red'
									: blogItem?.category === 'EXPLORE'
									? 'text-color-blue'
									: 'text-color-orange'
							}`}
						>
							{blogItem.category}
						</div>
						<div className='read-time text_small text-medium'>
							{blogItem.articleReadTime ?? '5 mins read'}
						</div>
					</div>
					<div className='blog-info-right published-date text_small text-medium'>
						{blogItem.articleDate ??
							FormatCreationDate(blogItem?.sys?.createdAt)}
					</div>
				</div>
				<h6 className='noto lower light mb-0'>{blogItem.title}</h6>
				<p className='description'>{blogItem?.headline}</p>
			</div>
		</StyledBlogItemGrid>
	);
};

export default BlogItemGrid;
